import React, { useEffect } from 'react'
import { AppProps } from '../App';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MainType } from './Navbar';
import { TbCreditCard, TbDatabaseSearch, TbFileLambda, TbFolderUp, TbSettings } from 'react-icons/tb';
import { HiOutlineHome, HiOutlineUserCircle } from "react-icons/hi";
import { PiChartLineBold, PiWrenchBold } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';


export type ConsoleService = 'project' | 'database' | 'storage';
export type SettingsOption = 'account' | 'plan-and-payments' 
export type ProjectService = 'database' | 'auth' | 'storage' | 'function' | 'metric' | 'config';
export type DocsOption = 'get-started' | 'database' | 'auth' | 'storage' | 'function' | 'example-1';

interface SidebarProps extends AppProps {
  setShowSidebar?: React.Dispatch<React.SetStateAction<boolean>>
}

export const SidebarContent = ({ setShowSidebar, ...props }: SidebarProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const query = new URLSearchParams(location.search);
  
  const [main, setMain] = React.useState<MainType>('project');
  const [settingsOption, setSettingsOption] = React.useState<'' | SettingsOption>('');
  const [projectService, setProjectService] = React.useState<'' | ProjectService>('');
  const [docsOption, setDocsOption] = React.useState<'' | DocsOption>('');

  // settings sidebar options
  useEffect(() => {
    const mainString = location.pathname.split('/')[1];
    setMain(mainString as MainType);
    
    if (mainString === 'settings') { // set settings option
      const option = params.option;
      if (!option || option === 'account' || option === 'plan-and-payments') {
        setSettingsOption(option ? option as SettingsOption : '');
        return;
      }
      navigate('/pagenotfound');
    } else if (mainString === 'project') { // set project service
      const service = params.service;
      if (!service || service === 'auth' || service === 'database' || service === 'storage' || service === 'function' || service === 'metric' || service === 'config') {
        setProjectService(service ? service as ProjectService : '');
        return;
      }
      navigate('/pagenotfound');
    } else if (mainString === 'docs') { // set docs option
      const option = query.get('d');
      if (!option || option === 'get-started' || option === 'database' || option === 'auth' || option === 'storage' || option === 'function' || option === 'example-1') {
        setDocsOption(option ? option as DocsOption : '');
        return;
      }
      navigate('/pagenotfound');
    }
  }, [location, navigate, params, query]);

  const goto = (path: string) => {
    navigate(path);
    setShowSidebar?.(false);
  }

  return (
    main === 'settings' ? <>
      <button onClick={() => goto('/settings')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${!settingsOption ? 'bg-primary/10 text-primary' : ''}`}><TbSettings className='mr-2' />{t('sidebar-menu.settings.general')}</button>
      {/* <button onClick={() => goto('/settings/account')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${settingsOption === 'account' ? 'bg-primary/10 text-primary' : ''}`}><FiUser className='mr-2' />{t('sidebar-menu.settings.account')}</button> */}
      <button onClick={() => goto('/settings/plan-and-payments')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${settingsOption === 'plan-and-payments' ? 'bg-primary/10 text-primary' : ''}`}><TbCreditCard className='mr-2' />{t('sidebar-menu.settings.plan-and-payments')}</button>
    </> : main === 'project' ? <>
      <div></div>
      <button onClick={() => goto(`/project/${params.projectId}`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${!projectService ? 'bg-primary/10 text-primary' : ''}`}><HiOutlineHome className='mr-2' />{t('sidebar-menu.project')}</button>
      <div className='border-b m-2' />
      <button onClick={() => goto(`/project/${params.projectId}/auth`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'auth' ? 'bg-primary/10 text-primary' : ''}`}><HiOutlineUserCircle className='mr-2' />{t('sidebar-menu.project.auth')}</button>
      <button onClick={() => goto(`/project/${params.projectId}/database`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'database' ? 'bg-primary/10 text-primary' : ''}`}><TbDatabaseSearch className='mr-2' />{t('sidebar-menu.project.database')}</button>  
      <button onClick={() => goto(`/project/${params.projectId}/storage`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'storage' ? 'bg-primary/10 text-primary' : ''}`}><TbFolderUp className='mr-2' />{t('sidebar-menu.project.storage')}</button>  
      <button onClick={() => goto(`/project/${params.projectId}/function`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'function' ? 'bg-primary/10 text-primary' : ''}`}><TbFileLambda className='mr-2' />{t('sidebar-menu.project.function')}</button>  
      <div className='border-b m-2' />
      {/* <button onClick={() => goto(`/project/${params.projectId}/metric`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'metric' ? 'bg-primary/10 text-primary' : ''}`}><PiChartLineBold className='mr-2' />{t('sidebar-menu.project.metric')}</button>   */}
      <button onClick={() => goto(`/project/${params.projectId}/config`)} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${projectService === 'config' ? 'bg-primary/10 text-primary' : ''}`}><PiWrenchBold className='mr-2' />{t('sidebar-menu.project.config')}</button>  
    </> : main === 'docs' ? <>
      <div className='text-xs font-bold mx-2 my-2'>{t('sidebar-menu.docs.get-started')}</div>
      <button onClick={() => goto('/docs?d=get-started')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${!docsOption || docsOption === 'get-started' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.quickstart')}</button>
      <div className='text-xs font-bold mx-2 my-2 mt-4'>{t('sidebar-menu.docs.services')}</div>
      <button onClick={() => goto('/docs?d=auth')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${docsOption === 'auth' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.auth')}</button>
      <button onClick={() => goto('/docs?d=database')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${docsOption === 'database' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.database')}</button>
      <button onClick={() => goto('/docs?d=storage')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${docsOption === 'storage' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.storage')}</button>
      <button onClick={() => goto('/docs?d=function')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${docsOption === 'function' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.function')}</button>
      <div className='text-xs font-bold mx-2 my-2 mt-4'>{t('sidebar-menu.docs.examples')}</div>
      <button onClick={() => goto('/docs?d=example-1')} className={`text-sm p-2 px-4 flex items-center hover:bg-primary/10 rounded-lg ${docsOption === 'example-1' ? 'bg-primary/10 text-primary' : ''}`}>{t('sidebar-menu.docs.example-1')}</button>
    </> : <></>
  )
}


export default SidebarContent